import { useEffect, useState } from "react";
import { classNames, classNamesOrEmpty } from "../../style/common";
import { ArrowPathIcon, FunnelIcon } from "@heroicons/react/24/outline";

export type ItemDisplayTooltipPosition = "top" | "relative";

export type ItemDisplayToolbarProps = {
    classNames?: {
        backgroundContainer?: string | undefined,
        container?: string | undefined,
        theme?: string | undefined
    },
    searchText: string,
    tooltipPosition: ItemDisplayTooltipPosition,
    onSearchTextEnterKey: (searchText: string) => void,
    onSearchTextChange: (text: string) => void,
    onFiltersClick: () => void,
    onResetClick: () => void,
    numberOfFiltersApplied: number,
    hideNumberOfFiltersApplied?: boolean,
    hideFilterButton?: boolean,
    hideSearch?: boolean,
    hideResetButton?: boolean,
    placeholderText?: string
}

export const positionMap = {
    "top": "pl-2 pr-4 fixed left-[58px] sm:left-[70px] lg:left-72 top-0 right-0 z-50",
    "relative": "pl-4 pr-4 relative -mx-4 md:-mx-8"
}

export default function ItemDisplayToolbar(props: ItemDisplayToolbarProps) {
    return (
        <>
            <div className={classNames(
                `lg:px-8 pointer-events-none bg-quarternary text-contrast-primary flex items-center justify-between h-14`,
                props.classNames?.theme === undefined ? "theme-dark" : "",
                positionMap[props.tooltipPosition],
                props.classNames?.container
            )}>
                <div className={`space-x-1 md:space-x-2 pointer-events-auto flex-1 flex w-full overflow-hidden ${props.hideSearch ? "justify-center" : ""}`}>
                    {
                        !props.hideSearch &&
                        <input
                            value={props.searchText}
                            placeholder={props.placeholderText || "Search Text"}
                            onFocus={(event) => event.currentTarget.select()}
                            onWheel={(event) => event.currentTarget.blur()}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    props.onSearchTextEnterKey(props.searchText);
                                    event.currentTarget.blur();
                                }
                            }}
                            onChange={(event) => {
                                if (!props.onSearchTextChange) {
                                    return;
                                }

                                props.onSearchTextChange(event.target.value);
                            }}
                            className="bg-slate-500 flex-1 rounded-md border-none text-white placeholder-gray-300 min-w-0 disabled:cursor-not-allowed"
                            type="text"
                        />
                    }

                    {
                        !props.hideFilterButton &&
                        <button
                            title="filters"
                            onClick={() => props.onFiltersClick()}
                            className="p-2  rounded-md space-x-1 flex justify-center items-center">
                            <FunnelIcon className="h-5 w-5" />

                            {
                                (!props.hideNumberOfFiltersApplied && props.numberOfFiltersApplied != undefined) &&
                                <span className="inline-flex items-center gap-x-1.5 rounded-full bg-contrast-primary px-1 text-xs font-normal text-contrast-quarternary">{props.numberOfFiltersApplied ?? 0}</span>
                            }
                        </button>
                    }

                    {
                        !props.hideResetButton &&
                        <button
                            title="reset"
                            onClick={() => props.onResetClick()}
                            className="p-2 rounded-md"
                        >
                            <ArrowPathIcon className="w-5 h-5" />
                        </button>
                    }
                </div>
            </div>
        </>
    )
}